module.exports = __webpack_public_path__ + "img/Kuwait-Portrait-english.c2b6ec7c.jpg";